import { Controller } from "@hotwired/stimulus"

// Opens a server-rendered <dialog> as a modal. Stimulus connects the controller
// when the element enters the DOM, which for these dialogs is the moment Turbo
// inserts the frame carrying them.
//
// <dialog data-controller="dialog" data-action="click->dialog#closeOnBackdrop">
//   <button type="button" data-action="dialog#close">Cancel</button>
// </dialog>
export default class extends Controller {
	connect() {
		if (!this.element.open) this.element.showModal()
	}

	close() {
		this.element.close()
	}

	// A click that lands on the dialog itself is a click on its backdrop: the
	// content sits in the children.
	closeOnBackdrop(event) {
		if (event.target === this.element) this.element.close()
	}
}
